<template lang="pug">
  button.button-delete(
  @click.prevent.stop="$emit('on-button-click')"
  )
    img.button-delete__icon(src="@/assets/images/icons/grey-cross.svg")
    img.button-delete__icon.button-delete__icon_hover(src="@/assets/images/icons/dark-grey-cross.svg")
</template>

<script>
export default {
  name: "ButtonDelete"
};
</script>
